import React, { useState, useContext } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import * as Sentry from '@sentry/react';
// import mixpanel from 'mixpanel-browser';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLoading } from '../../context/LoadingContext';
import '../../styles/WomReferralForm.scss';
import MdReferralForm from './forms/MdReferralForm';
import { validateAndScroll } from '../intake_new/intake-utilities';
import { generateUniqueId, triggerMdreferralWorkflow, useStateWithSentry } from '../../utilities/common';

export default function MdReferralFormContainer() {
  const { setIsLoading } = useLoading();

  const [formData, setFormData] = useStateWithSentry('formData', {});
  // const [phoneNumber, setPhoneNumber] = useStateWithSentry('phoneNumber', {});
  // Patient SMS consent. Kept out of formData on purpose: triggerMdreferralWorkflow
  // spreads formData into the row it writes to the md_referral CSVs, so a key
  // here would end up in those files.
  const [smsConsent, setSmsConsent] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // validation
  const [validation, setValidation] = useState({});
  const [showFormErrors, setShowFormErrors] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    toast.dismiss();
    setIsLoading(true);
    if (!validateAndScroll(e.target, setShowFormErrors)) {
      return;
    }
    setShowFormErrors(false);
    setIsLoading(true);

    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      const blobPath = `${import.meta.env.VITE_MD_RAW_FILE_PATH}`;
      const uniqueId = generateUniqueId();
      const specificBlobName = `md-referral-payload-${uniqueId}`;

      await triggerMdreferralWorkflow({
        formData,
        blobPath,
        specificBlobName
      });

      toast.success('MD referral form submitted successfully', {
        autoClose: false, // stays on screen until closed
        closeOnClick: true // allow user to click to close
      });

      setFormData({ patient_phone_number: [''] }); //clear formdata
      setSmsConsent(false); // every referral needs its own consent tick
      //   mixpanel.track('IntakeForm: Submitted', { email });
    } catch (error) {
      Sentry.captureException(error, { extra: { formData } });
      toast.error('Sorry, something went wrong on our end. Please try again.');
    } finally {
      // Hide spinner after simulated delay
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Form className="intake-form-container" onSubmit={handleSubmit}>
        <Container className="mb-5">
          <MdReferralForm
            formData={formData}
            setFormData={setFormData}
            formErrors={formErrors}
            smsConsent={smsConsent}
            setSmsConsent={setSmsConsent}
          />
        </Container>
        <Container className="d-flex justify-content-center mb-5">
          <Button type="submit" variant="primary">
            Submit Form
          </Button>
        </Container>
      </Form>
    </div>
  );
}
